/*
 * Module for the ckeditor topic link widget.  It is used to select a topic to link using a typeahead
 * search bar.  It also displays the currently selected topic (it is passed the topic id)
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/shared/topicSelector/topicSelectorView",
], function (Marionette, Backbone, Messenger, TopicSelectorView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicSelector";
      this.namespace = options.namespace;
      this.region = options.region;
      this._setUpVents();
    },
    show: function (intentId) {
      const topicModel = this._createModelFromIntentId(intentId);
      this._replaceView(topicModel);
    },
    setIntentId: function (intentId) {
      const topicModel = this._createModelFromIntentId(intentId);
      this._replaceView(topicModel);
    },
    _createModelFromIntentId: function (intentId) {
      if (intentId) {
        // Fetch the topic model for the given intentId, even if it matches what is currently being
        // displayed
        const model = Messenger.reqres.request("fetch:topic", intentId);
        // If the topic cannot be loaded, then show an error message
        this.listenToOnce(model, "error", () => {
          if (this.view) {
            this.view.noTopicError();
          }
        });
        return model;
      } else {
        // Just create a blank dummy object
        return new Backbone.Model({
          intentName: "",
          intentDescription: "",
        });
      }
    },
    _createView: function (model) {
      const view = new TopicSelectorView.topicSelectorView({ model: model });
      view.on("search", this._onSearch, this);
      return view;
    },
    _onSearch: function (query) {
      const topicSearchResults = Messenger.reqres.request("search:topics:by:name", query).topics();
      topicSearchResults.onSynced(() => {
        //need to make sure that we return the topic with the matching name (and not one that is a partial match)
        for (let i = 0; i < topicSearchResults.length; i++) {
          if (topicSearchResults.at(i).get("intentName") === query) {
            //set the model to be shown in the view and rerender
            const topicModel = topicSearchResults.at(i);
            this._replaceView(topicModel);

            //get the labels for the searched topic (must be synced)
            const reqLabels = topicSearchResults.at(i).topicLabels();
            reqLabels.onSynced(() => {
              this.trigger("topic:search:selected", topicSearchResults.at(i), reqLabels);
            });
            break;
          }
        }
      });
    },
    _replaceView: function (model) {
      // For some reason using view.render() in a CKEditor popup doesn't properly update the
      // view, so removing and creating a new one is the safest option.
      if (this.view) {
        this.view.close();
        this.view = null;
      }
      this.view = this._createView(model);
      this.showRegion(this.view, { loading: true });
    },
    _setUpVents: function () {
      Messenger.vent.on(
        Messenger.getFullName("topic:search:image:selected", this.namespace),
        function (intentId) {
          this.show(intentId);
        },
        this,
      );
    },
  });
});
